import { render, staticRenderFns } from "./SocialIcons.vue?vue&type=template&id=189f234b&scoped=true"
import script from "./SocialIcons.js?vue&type=script&lang=js&external"
export * from "./SocialIcons.js?vue&type=script&lang=js&external"
import style0 from "./SocialIcons.scss?vue&type=style&index=0&id=189f234b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f234b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Icon/Icon.vue').default,HotLink: require('/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Atoms/Link/Link.vue').default})
